import request from '@/api/request'

//PC工作台-项目列表
export function addressList(data) {
    return request({
        url: '/api/director/address/lists',
        method: 'GET',
        params: data
    })
}


//PC工作台-地址添加
export function addAddress(data) {
    return request({
        url: '/api/director/address/add',
        method: 'POST',
        data
    })
}
export function batchAddAddress(data) {
    return request({
        url: '/api/director/address/adds',
        method: 'POST',
        data
    })
}




//PC工作台-地址详情
export function addressInfo(data) {
    return request({
        url: '/api/director/address/info',
        method: 'GET',
        params: data
    })
}

//PC工作台-地址修改
export function updateAddress(data) {
    return request({
        url: '/api/director/address/edit',
        method: 'POST',
        data
    })
}

//PC工作台-地址删除
export function delAddress(data) {
    return request({
        url: '/api/director/address/del',
        method: 'GET',
        params: data
    })
}

export function addressAllList(data) {
    return request({
        url: '/api/job/whole/address/list',
        method: 'GET',
        params: data
    })
}

